// @ts-nocheck
import React, { useState, useEffect } from 'react';
import Router, { useRouter } from 'next/router';
import Fetch from '@/utils/Fetch';
import * as Enums from '@/utils/enums';
import Storage from '@/utils/storage';
import Helper from '@/utils/helper';
import ManageSupplier from '@/components/supplier/manage';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router'

function EditSupplier() {

    const router = useRouter();
    const { id } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch

    const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
    const [multiStoreTenant, setMultiStoreTenant] = useState(false);
  
    const getAccessStatus = () => {
        let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
        if (subscriptionInfo) {
            setAccessStatus(subscriptionInfo.AccessStatus);
            setMultiStoreTenant(subscriptionInfo.MultiStore);
        }
    };
  
    useEffect(() => {
        getAccessStatus();
    }, []);
    
    useEffect(() => {
        if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
            Helper.nextRouter(Router.replace, "/");
        }
    }, [accessStatus]);

    const { data: supplier } = useQuery(
        ['supplier', id],
        () => Fetch.get({ url: `/Supplier/${id}` }),
        { enabled: !!id }
    );

    if (!supplier) return null;

    return (
        <div>
            <ManageSupplier isNew={false} manageSupplier={supplier} accessStatus={accessStatus} multiTenantStore={multiStoreTenant} />
        </div>
    );
}

export default EditSupplier;

export const Route = createFileRoute('/_authenticated/supplier/$id')({ component: EditSupplier })
